import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaFeatherAlt } from "react-icons/fa";
import { AiOutlineSend } from "react-icons/ai";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { createArticle, resetVariables } from "../../State/Article/Action";

const CreateNote = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { chapterId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const moduleId = queryParams.get("moduleId");

  const [editorContent, setEditorContent] = useState("");

  const { loadingCreate, errorCreate, createArticleResult } = useSelector(
    (state) => state.article
  );

  const handleChange = (content) => {
    setEditorContent(content);
  };

  const handleSubmit = () => {
    if (editorContent.trim().length !== 0) {
      dispatch(createArticle(chapterId, editorContent));
    } else {
      toast.error("Article content cannot be empty.");
    }
  };

  useEffect(() => {
    if (createArticleResult?.data?.id) {
      toast.success("Article created successfully!");
      dispatch(resetVariables());
      // Get courseId from the current URL or module data
      const courseId = new URLSearchParams(window.location.search).get('courseId');
      if (courseId) {
        navigate(`/add-new/${moduleId}?courseId=${courseId}`);
      } else {
        navigate("/add-new/" + moduleId);
      }

      // Optionally navigate somewhere:
      // navigate(`/article/${createArticleResult.id}`);
    }
  }, [createArticleResult]);

  useEffect(() => {
    if (errorCreate) {
      toast.error("Failed to create article.");
      dispatch(resetVariables());
    }
  }, [errorCreate]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 flex justify-center items-center p-4">
      <div className="bg-white/30 backdrop-blur-lg rounded-xl shadow-xl p-8 w-full max-w-4xl">
        <div className="flex items-center gap-3 mb-6">
          <FaFeatherAlt className="text-5xl text-white drop-shadow" />
          <h1 className="text-3xl sm:text-4xl font-bold text-white drop-shadow font-montserrat">
            Write Your Article
          </h1>
        </div>

        <div className="mb-6">
          <ReactQuill
            value={editorContent}
            onChange={handleChange}
            className="bg-white rounded-md"
            theme="snow"
            style={{ minHeight: "250px" }}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                [{ font: [] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                ["clean"],
              ],
            }}
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={loadingCreate}
          className={`w-full sm:w-auto flex items-center gap-2 justify-center bg-white text-purple-700 px-6 py-3 rounded-full font-semibold text-lg shadow-md transition hover:scale-105 hover:bg-purple-100 hover:text-purple-900 ${
            loadingCreate ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {loadingCreate ? (
            <span>Saving...</span>
          ) : (
            <>
              <AiOutlineSend className="text-xl" /> Create Article
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default CreateNote;
